import { c as _c } from "react/compiler-runtime";
import { IcoPencil16 } from '@onefootprint/icons';
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import Item from '@/playbook-builder/components/item';
import Section from '@/playbook-builder/components/section';
import SubSection from '@/playbook-builder/components/sub-section';
import type { BusinessDataNodeProps, CollectDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import { collectsData } from '../identity-data-node/utils/data-collection-utils';
type BusinessInformationViewProps = {
  canEdit: boolean;
  node: CollectDataNodeProps | BusinessDataNodeProps;
  onEdit: () => void;
};
const BusinessInformationView = t0 => {
  const $ = _c(25);
  const {
    canEdit,
    node: t1,
    onEdit
  } = t0;
  const {
    data
  } = t1;
  const collects = collectsData(data);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "collectData.business"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t2);
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== canEdit || $[4] !== onEdit || $[5] !== t) {
    t4 = canEdit ? <LinkButton variant="label-2" iconComponent={IcoPencil16} iconPosition="left" onClick={onEdit}>{t(_temp2)}</LinkButton> : null;
    $[3] = canEdit;
    $[4] = onEdit;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp3);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp4);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp5);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp6);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t(_temp7);
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t(_temp8);
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const T0 = Item;
  let t11;
  if ($[19] !== t) {
    t11 = t(_temp9);
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = collects("business_phone_number");
  let t13;
  if ($[21] !== T0 || $[22] !== t11 || $[23] !== t12) {
    t13 = <T0 label={t11} value={t12} />;
    $[21] = T0;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return <Section title={t3} actions={t4}><SubSection title={t5}><Item label={t6} value={collects("business_name")} /><Item label={t7} value={collects("business_address")} /><Item label={t8} value={collects("business_tin")} /><Item label={t9} value={collects("business_corporation_type")} /><Item label={t10} value={collects("business_website")} />{t13}</SubSection></Section>;
};
export default BusinessInformationView;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.edit;
}
function _temp3($_1) {
  return $_1.basic.title;
}
function _temp4($_2) {
  return $_2.basic.name;
}
function _temp5($_3) {
  return $_3.basic.address;
}
function _temp6($_4) {
  return $_4.basic.tin;
}
function _temp7($_5) {
  return $_5.basic.entity_type;
}
function _temp8($_6) {
  return $_6.basic.website;
}
function _temp9($_7) {
  return $_7.basic.phone;
}